import { DatePipe, formatDate } from '@angular/common'
import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { Observable, of } from 'rxjs'
import { BaseDialogComponent } from '../../../../base/dialog-base/dialog-base.component'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { DialogService, FormulaireService, StateService, UtilitaryService } from '../../../../services'
import { AtylService } from '../../../service/atyl.service'


@Component({
	selector: 'form-dialog-formulaire',
	styleUrls: ['./form-dialog-formulaire.component.css'],
	templateUrl: 'form-dialog-formulaire.component.html',
})
export class FormDialogFormulaireComponent extends BaseDialogComponent implements OnInit {
	loadingPrint: boolean = false;
	dateForm: any
	title: string = '';
	atylComponents: string = '';
	atylTemplate: string = '';
	atylDocuments: string = '';
	atylDemand: any
	atylDossier: any
	actionForm: string = '';
	statusForm: string = '1';
	avisForm: string = '0';

	id: string = '';
	typeDemande: string = '';
	typeFormulaire: string = '';
	nextState: string = '';
	currentForm: any
	loading: boolean = true;
	changeUrl: boolean = false;
	demande: any
	isEditable: boolean = true;
	hasSaveButton: boolean = true;
	@Output() submited = new EventEmitter<any>();

	color: string = '';
    intervention: any;
    
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private atylService: AtylService,
		private stateService: StateService,
		changeDetectorRef: ChangeDetectorRef,
		private utilities: UtilitaryService,
		private datePipe: DatePipe,
		private snackbar: MatSnackBar,
		private formulaireService: FormulaireService,
		dialogService: DialogService,
		public dialogRef: MatDialogRef<FormDialogFormulaireComponent>
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {

		this.atylComponents = ''
		this.atylTemplate = ''
		this.atylDocuments = ''
		this.atylDemand = ''
		this.typeDemande = this.data.typeDemande
		this.typeFormulaire = this.data.typeFormulaire
		this.title = this.data.title
		this.atylService.updateDossier(this.data.dossierId)
		if (this.data.color) {
			this.color = this.data.color
		}

        if (this.data != undefined && this.data.intervention != undefined  && this.data.intervention) {
            this.intervention = this.data.intervention
        }   
            
		if ((this.atylDossier == undefined || !this.atylDossier) && this.data.dossier != undefined && this.data.dossier) {
			this.atylDossier = this.data.dossier
		}
		
		if (this.data != undefined && this.data.intervention != undefined  && this.data.intervention) {
            this.intervention = this.data.intervention
        }

		if (this.data.form) {
			this.subscriptions.push(
				this.atylService.getFormulaireByID(this.data.demandeFormulaire.ID).subscribe((res: JSONRpcResponse) => {
					if (res.result) {
						this.dateForm = this.datePipe.transform(res.result.creationdate)
						this.atylComponents = JSON.stringify(res.result.form.fields)
						this.atylTemplate = res.result.form.template
						this.atylDocuments = JSON.stringify(res.result.form.documents)
						this.atylDemand = res.result.form
						this.demande = res.result
						this.currentForm = res.result.form
						this.actionForm = 'formulaire:set'
						if (res.result.status != undefined) {
							this.statusForm = String(res.result.status)
						}
						if (res.result.favorable != undefined)
							this.avisForm = String(res.result.favorable)
					}
					this.loading = false
					this.changeDetectorRef.detectChanges()
				})
			)
		}
		else if (this.data && this.data.loadedForm) {
			this.atylComponents = JSON.stringify(this.data.loadedForm.form.fields)
			this.atylTemplate = this.data.loadedForm.form.template
			this.atylDocuments = JSON.stringify(this.data.loadedForm.documents)
			this.atylDemand = this.data.loadedForm
			this.demande = this.data.loadedForm
			this.actionForm = 'formulaire:set'
			this.loading = false
			this.changeDetectorRef.detectChanges()
		}
		else {
			let _options = {
				dossierId: this.data.dossierId ? this.data.dossierId : (this.data.dossier ? this.data.dossier.ID : null),
				tiersId: this.data.tiersId ? this.data.tiersId : (this.data.dossier.tiers ? this.data.dossier.tiers.ID : null),
			}
			this.subscriptions.push(
				this.formulaireService.new_v3(this.data.typeFormulaire, _options)
					.subscribe((formulaire: JSONRpcResponse) => {
						this.atylComponents = JSON.stringify(formulaire.result.form.fields)
						this.atylTemplate = formulaire.result.form.template
						this.atylDocuments = JSON.stringify(formulaire.result.documents)
						this.atylDemand = formulaire.result
						this.demande = formulaire.result
						this.hasSaveButton = false
						this.actionForm = 'formulaire:set'
						this.loading = false
						this.changeDetectorRef.detectChanges()
					})
			)
		}
		if (this.data.isEditable !== undefined)
			this.isEditable = this.data.isEditable
	}

	ngAfterViewInit() {
	}

	onLoaded(loaded: boolean) {
		if (loaded)
			this.changeDetectorRef.markForCheck()
	}
	canDeactivate(): Observable<boolean> | boolean {
		let i = 0

		if (this.atylDemand && this.atylDemand.form && this.atylDemand.form.fields && this.atylDemand.form.fields.length > 0) {
			this.utilities.log(this.atylDemand.form.fields)
			this.atylDemand.form.fields.forEach((field) => {
				if (field.value && field.value != '')
					i++
			})
		}
		if (i != 0 && !this.changeUrl)
			return of(window.confirm('Voulez-vous abandonner le formulaire en cours ?'))
		else
			return true
	}

	onSubmit(values: any) {
		this.atylDemand.documents = values.DOCUMENTS
		if (!values['close'])
			this.data.closeWhenValidate = false
		else if (values['close'])
			this.data.closeWhenValidate = true
		if (this.currentForm)
			this.atylDemand.form = this.currentForm
		for (var i = 0; i < this.atylDemand.form.fields.length; i++) {
			var field = this.atylDemand.form.fields[i]
			if (values.hasOwnProperty(field.ID)) {
				var val = values[field.ID]

				if (field.field.type == 'date' && val != '') {
					var utcDate = formatDate(val, 'yyyy-MM-ddTHH:mm:ss', 'fr-FR')
					val = utcDate
				}

				field['value'] = val
				this.atylDemand.form.fields[i] = field
			}
		}
		if (this.currentForm) {
			this.atylDemand.form = {
				form: this.currentForm.ID,
				key: this.currentForm.key
			}
		}
		if (this.nextState)
			this.atylDemand.transition = this.nextState
		if (!this.atylDemand.ID) {
			console.log('if ID', this.currentForm.ID, this.data.key, this.atylDossier)

			let dossierID = (this.atylDossier != undefined && this.atylDossier && this.atylDossier.ID != undefined) ? this.atylDossier.ID : null
			this.subscriptions.push(
				this.atylService.setNewFormulaire(this.currentForm.ID, this.currentForm.fields, this.data.id ? this.data.id : '', (this.data.instruction && this.data.instruction.ID ? this.data.instruction.ID : ''), this.currentForm.parent ? '' : this.data.id, values.etat, values.favorable, dossierID,null,this.intervention)
					// this.atylService.setNewFormulaire(this.typeFormulaire, this.atylDemand.fields, (this.data.instruction && this.data.instruction.ID ? this.data.instruction.ID : ''))
					.subscribe((submitted: JSONRpcResponse) => {
						this.submited.emit(submitted)
						this.changeUrl = true

						let snackBarRef = this.snackbar.open('Formulaire enregistré', '', {
							duration: 2500
						})
						if (this.data.closeWhenValidate)
							this.dialogRef.close(submitted)
						this.changeDetectorRef.detectChanges()
					})
			)
		}
		else {
			// this.atylService.setFormulaire(this.atylDemand, this.data.instruction, this.data.demandeFormulaire.ID, values.etat, '', values.favorable).subscribe((res) => {
			let dossierID = (this.atylDossier != undefined && this.atylDossier && this.atylDossier.ID != undefined) ? this.atylDossier.ID : null

			let dtint = (this.data.instruction != undefined && this.data.instruction) ? this.data.instruction : null
			let parentID = null
			if ((this.currentForm.parent != undefined && this.currentForm.parent) || (this.data.id != undefined))
				parentID = (this.currentForm.parent != undefined && this.currentForm.parent) ? '' : this.data.id
			console.log('else ID 2', this.currentForm, dtint, this.data.demandeFormulaire.ID, values.etat, parentID, values.favorable ? values.favorable : '0', dossierID)
			this.subscriptions.push(
				this.atylService.setFormulaire(this.currentForm, dtint, this.data.demandeFormulaire.ID, values.etat, parentID, values.favorable ? values.favorable : '0', dossierID,this.intervention).subscribe((res: JSONRpcResponse) => {

					this.submited.emit(res.result)
					this.changeUrl = true

					let snackBarRef = this.snackbar.open('Formulaire enregistré', '', {
						duration: 2500
					})
					if (this.data.closeWhenValidate)
						this.dialogRef.close(res.result)
					this.changeDetectorRef.detectChanges()
				}, (err) => {
					console.error(err)
				}, () => {
					this.stateService.formulairesUpdate(true)
				})
			)
		}
	}

	getSubmittedEmitter() {
		return this.submited
	}

	CheckSendDossier(type: string) {
		if (type == 'RENOUVELLEMENT' || type == 'MODIFICATION' || type == 'DEMENAGEMENT' || type == 'INITIALE')
			return true
		else
			return false
	}

	printForm(id: any) {
		this.subscriptions.push(
			this.atylService.printFormulaire(id, true, false).subscribe((res: JSONRpcResponse) => {
				this.loadingPrint = false
				console.log('printed', res)
				/* if (res.result && res.result.length > 0)
				   window.open(res.result[0].value.url);
				   */
				if (res.result && res.result.url != undefined)
					window.open(res.result.url)
				else
					of(window.confirm('Pas de donnée disponible'))

			})
		)
	}
}
